export function alignAxisLabels(labels, start, containerSize, orient, align) {
    if ("right" === orient || "left" === orient) {
        if ("left" === align) {
            const flag = "right" === orient ? 0 : -1;
            labels.forEach((label => {
                label.setAttributes({
                    x: start + containerSize * flag,
                    textAlign: "left"
                });
            }));
        } else if ("right" === align) {
            const flag = "right" === orient ? 1 : 0;
            labels.forEach((label => {
                label.setAttributes({
                    x: start + containerSize * flag,
                    textAlign: "right"
                });
            }));
        } else if ("center" === align) {
            const flag = "right" === orient ? 1 : -1;
            labels.forEach((label => {
                label.setAttributes({
                    x: start + .5 * containerSize * flag,
                    textAlign: "center"
                });
            }));
        }
    } else if ("bottom" === orient || "top" === orient) if ("top" === align) {
        const flag = "bottom" === orient ? 0 : -1;
        labels.forEach((label => {
            label.setAttributes({
                y: start + containerSize * flag,
                textBaseline: "top"
            });
        }));
    } else if ("bottom" === align) {
        const flag = "bottom" === orient ? 1 : 0;
        labels.forEach((label => {
            label.setAttributes({
                y: start + containerSize * flag,
                textBaseline: "bottom"
            });
        }));
    } else if ("middle" === align) {
        const flag = "bottom" === orient ? 1 : -1;
        labels.forEach((label => {
            label.setAttributes({
                y: start + .5 * containerSize * flag,
                textBaseline: "middle"
            });
        }));
    }
}
//# sourceMappingURL=align.js.map
